import React from 'react'
import {Flex} from '/app/src/component'
import {withHover} from "/app/src/hoc"
import Theme from '/app/src/theme';
import SVG from 'react-inlinesvg'


const iconStyle = {
    fill: Theme.colors.JibberPurple_L,
    width: "40px",
    height: "40px",
    marginRight: "15px"
}

const textStyle = (isHovered) => {
    return {
        fontSize: "20px",
        color: isHovered ? Theme.colors.JibberPurple_M : Theme.colors.MediumGray5,
        vAlignContent: "center"
    }
}

const StatisticsUpgradeText = ({isHovered, onClick}) => (
    <Flex onClick={onClick}>
        <Flex>
            <SVG
                cacheGetRequests={true}
                src='/images/ShootingStar_L.svg'
                style={iconStyle}/>
        </Flex>
        <Flex {...textStyle(isHovered)}>
            Vi har mer statistik till dig!
        </Flex>
    </Flex>
)


export default withHover(StatisticsUpgradeText)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Overview/StatisticsUpgradeText.js